<template>
  <b-card
    class="mb-0 bank-details mx-auto"
    style="max-width: 600px;"
  >
    <div class="pricing-trial-content d-flex justify-content-between text-center">
      <div class="w-100">
        <div
          v-if="bankAccount"
          class="mx-auto mx-md-0"
        >
          <b-card class="bg-dark-blue text-white">
            <b-row
              class="d-flex"
              dir="rtl"
            >
              <b-col class="text-center text-lg-right ">
                <template v-if="bankAccount.card_number">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('account_number') }}</span>
                  <span class="pa-2 d-block">{{ bankAccount.account_number }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.iban">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('iban') }}</span>
                  <span class="pa-2 d-block">{{ bankAccount.iban }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.card_name">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('account_owner') }}</span>
                  <span class="pa-2 d-block">{{ bankAccount.card_name }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.bank_name">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('bank') }}</span>
                  <span class="pa-2 d-block">{{ bankAccount.bank_name }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.min_deposit_amount">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('min_deposit_amount') }}</span>
                  <span
                    dir="ltr"
                    class="pa-2 d-block"
                  >{{ helpers.numberWithCommas(bankAccount.min_deposit_amount)+' ' + bankAccount.currency.name }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.max_deposit_amount">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('max_deposit_amount') }}</span>
                  <span
                    dir="ltr"
                    class="pa-2 d-block"
                  >{{ helpers.numberWithCommas(bankAccount.max_deposit_amount)+' ' + bankAccount.currency.name }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.fee">
                  <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('fee') }}</span>
                  <span
                    dir="ltr"
                    class="pa-2 d-block"
                  >{{ helpers.numberWithCommas(bankAccount.fee)+' ' + bankAccount.currency.name }}</span>
                  <br>
                </template>
              </b-col>
              <b-col
                cols="1"
                class="text-center text-lg-right d-none d-lg-block"
              >
                <template v-if="bankAccount.card_number">
                  <span class="pa-2  d-block">:</span>
                  <br>
                </template>
                <template v-if="bankAccount.iban">
                  <span class="pa-2 d-block">:</span>
                  <br>
                </template>
                <template v-if="bankAccount.card_name">
                  <span class="pa-2 d-block">:</span>
                  <br>
                </template>
                <template v-if="bankAccount.bank_name">
                  <span class="pa-2 d-block">:</span>
                  <br>
                </template>
                <template v-if="bankAccount.min_deposit_amount">
                  <span class="pa-2 d-block">:</span>
                  <br>
                </template>
                <template v-if="bankAccount.max_deposit_amount">
                  <span class="pa-2 d-block">:</span>
                  <br>
                </template>
                <template v-if="bankAccount.fee">
                  <span class="pa-2 d-block">:</span>
                  <br>
                </template>
              </b-col>
              <b-col
                cols="5"
                class="text-center text-lg-right   d-none d-lg-block"
              >
                <template v-if="bankAccount.card_number">
                  <span class="pa-2 text-nowrap d-block">{{ $t('account_number') }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.iban">
                  <span class="pa-2 d-block">{{ $t('iban') }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.card_name">
                  <span class="pa-2 d-block">{{ $t('account_owner') }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.bank_name">
                  <span class="pa-2 d-block">{{ $t('bank') }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.min_deposit_amount">
                  <span class="pa-2 d-block">{{ $t('min_deposit_amount') }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.max_deposit_amount">
                  <span class="pa-2 d-block">{{ $t('max_deposit_amount') }}</span>
                  <br>
                </template>
                <template v-if="bankAccount.fee">
                  <span class="pa-2 d-block">{{ $t('fee') }}</span>
                  <br>
                </template>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { numberWithCommas } from '@/utils'

export default {
  name: 'BankAccountDetails',
  props: {
    bankAccount: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      helpers: {
        numberWithCommas,
      },
    }
  },
}
</script>

<style scoped>
.bg-dark-blue {
  background-color: rgb(2, 58, 110);
}
</style>
